/**
 * Look for a slug on a given sitemap by using just the node id
 *
 * @param nid: the node numeric id
 * @param sitemap: a sitemap to look into
 * @returns
 */

module.exports = function findPathFromEntityId(nid, sitemap) {
	let node_ref = sitemap.find((item) => parseInt(item.nid) === parseInt(nid));
	if (node_ref) {
		return node_ref.slug;
	} else {
		return null;
	}
};
